export class BaseWearerModel {
  id = '';
  localId? = '';
  firstName? = '';
  lastName? = '';
  displayName? = '';
  isResident = false;
  roomName?: string;
  bedName?: string;
  slotName?: string;
  bedslotId?: string;
  appRoomName?: string;
  etectId?: string;
}

export class WearerDetail extends BaseWearerModel {
  bandId = '';
  facilityId = '';
  alertSpike = 0;
  wearerGroupId = '1';
  isDeleted = false;
  alertSettings?: any;
}

export class WearerDetailsModel {
  bands: Band[] = [];
  rooms: Room[] = [];
  beds: Bed[] = [];
  residentDetail = new WearerDetail();
  wearerId: any;
  bandId: any;
  tagId?: any;
  alertSettings?: any;
  slotName = '';
  bedslotId = '';
  etectDetails?: EtectDetails = new EtectDetails();
}

class EtectDetails {
  etectId: number | null = null;
  etectMonitoringStatus = '';
  etectAlertStatus = '';
}

export class Room {
  id = '';
  roomName = '';
  slotName = '';
  deviceDetails?: any;
}

export class Bed {
  id = '';
  bedName = '';
  bedMetaData?: any;
  deviceDetails?: any;
}

export class Band {
  bandId = '';
  tagId?: any;
  alertThreshold? = 36.5;
  assignedDate? = 0;
  gracePeriod? = 10;
  location? = false;
  locationAlert? = false;
  isTag? = false;
}

export class BandStatus extends BaseWearerModel {
  corpId = '';
  facilityId = '';
  bandId = 0;
  isTag = false;
  firmwareVersion? = '';
  notFoundInGivenFacility = false;
  assetId? = '';
  wearerId? = '';
}

export interface WearerGroup {
  id: string;
  label: string;
  wearerGroupName: string;
}

export interface AssignBandToWearer {
  alertThreshold?: number;
  roomId: string;
  roomName: string;
  wearerId?: string;
  firstName?: string;
  lastName?: string;
  bandId?: string;
  assignedDate?: string;
  location?: boolean;
  locationAlert?: boolean;
  gracePeriod?: string;
  isTag?: boolean;
}
